import { useCallback, useState } from 'react';

import { Card, Typography } from 'antd';

import { NEWPRODUCT_URL } from 'settings';
import { useGetBetaFeatures } from 'v2/hooks/useGetBetaFeatures';
import { usePostMessage } from 'v2/hooks/usePostMessage';
import { PostMessageAction, PostMessageSource } from 'v2/interfaces/post-message';

import { Icon } from '@eduzz/ui-antd-theme';

const BETA_FEATURE_KEY = 'ai_product_creation';

function AIButtonRedirect() {
  const { data: betaFeatures } = useGetBetaFeatures();
  const sendPostMessage = usePostMessage();
  const [isHovered, setIsHovered] = useState(false);
  const aiProductCreationIsActive = betaFeatures?.includes(BETA_FEATURE_KEY);

  const onClick = useCallback(() => {
    sendPostMessage({
      source: PostMessageSource.PRODUCT_MANAGER,
      action: PostMessageAction.CLICK_BUTTON_FIGUEIRA,
      data: { date: new Date().toISOString() }
    });
  }, [sendPostMessage]);

  if (!aiProductCreationIsActive) return null;

  return (
    <div className='my-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'>
      <div className='col-span-full flex items-center gap-2'>
        <Icon.Sparkles size={24} className='size-6 shrink-0 text-(--uizz-antd-color-primary)' />
        <Typography.Text type='secondary' className='text-sm'>
          Estamos testando um novo formato de cadastro de e-books com apoio de Inteligência Artificial. Quer
          experimentar?
        </Typography.Text>
      </div>
      <Typography.Link
        id='new-product-ai-redirect'
        href={NEWPRODUCT_URL}
        target='_blank'
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className='block h-full no-underline'
      >
        <div
          className={`rounded-lg p-px transition-colors duration-200 ${
            isHovered
              ? 'bg-linear-to-br from-(--uizz-antd-color-primary) via-(--uizz-antd-color-info) to-(--uizz-antd-color-warning)'
              : 'bg-(--uizz-antd-color-border)'
          }`}
        >
          <Card
            className={`h-full min-h-35 cursor-pointer rounded-[calc(0.5rem-1px)] border-none shadow-none transition-colors duration-200 hover:shadow-none ${
              isHovered ? 'bg-(--uizz-antd-color-primary-bg)' : 'bg-(--uizz-antd-color-bg-container)'
            }`}
            classNames={{ body: 'h-full p-4' }}
          >
            <div className='flex h-full flex-col gap-3 text-left'>
              <div className='flex items-center gap-2'>
                <Icon.BookOpen size={20} className='size-5 text-(--uizz-antd-color-primary)' />
                <Typography.Text strong className='text-base'>
                  Apoio inteligente
                </Typography.Text>
              </div>
              <Typography.Text type='secondary' className='text-sm'>
                Use a IA para receber sugestões e orientações durante o cadastro do seu e-book.
              </Typography.Text>
            </div>
          </Card>
        </div>
      </Typography.Link>
    </div>
  );
}

export default AIButtonRedirect;
